/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonitoredDomain } from './MonitoredDomain';
import {
    MonitoredDomainFromJSON,
    MonitoredDomainFromJSONTyped,
    MonitoredDomainToJSON,
    MonitoredDomainToJSONTyped,
} from './MonitoredDomain';

/**
 * 
 * @export
 * @interface PaginatedMonitoredDomainList
 */
export interface PaginatedMonitoredDomainList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMonitoredDomainList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMonitoredDomainList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMonitoredDomainList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<MonitoredDomain>}
     * @memberof PaginatedMonitoredDomainList
     */
    results: Array<MonitoredDomain>;
}

/**
 * Check if a given object implements the PaginatedMonitoredDomainList interface.
 */
export function instanceOfPaginatedMonitoredDomainList(value: object): value is PaginatedMonitoredDomainList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedMonitoredDomainListFromJSON(json: any): PaginatedMonitoredDomainList {
    return PaginatedMonitoredDomainListFromJSONTyped(json, false);
}

export function PaginatedMonitoredDomainListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedMonitoredDomainList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(MonitoredDomainFromJSON)),
    };
}

  export function PaginatedMonitoredDomainListToJSON(json: any): PaginatedMonitoredDomainList {
      return PaginatedMonitoredDomainListToJSONTyped(json, false);
  }

  export function PaginatedMonitoredDomainListToJSONTyped(value?: PaginatedMonitoredDomainList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(MonitoredDomainToJSON)),
    };
}

